<template>
    <div :class="alignRight ? 'text-right' : ''">
        <div class="small" v-html="title || 'Add target:'"></div>
        <div class="d-flex" :class="alignRight ? 'justify-content-end' : ''">
            <input
                type="text"
                id="target-list-input"
                v-model="item"
                name="target"
                class="custom-input mr-2"
                :class="{ 'border-danger': itemAlreadyExists }"
                :placeholder="placeholder"
                @keyup.enter.prevent=""
            />
            <button
                class="btn btn-sm bg-white btn-outline-primary"
                id="add_target"
                name="add-target"
                v-tooltip="'Add target'"
                @click.prevent="pushItem()"
            >
                <i class="text-primary fa fa-plus"></i>
            </button>
        </div>
        <span class="small font-italic text-danger">{{
            itemAlreadyExists ? "This item is already present in the list." : " "
        }}</span>
        <div>
            <span class="small badge-light p-1 m-1 rounded" v-for="i in value">
                {{ i }}
                <i class="fa fa-times-circle cursor-pointer ml-1" @click="removeItem(i)"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsTargetList",
    props: ["value", "title", "placeholder", "alignRight"],
    data() {
        return {
            list: [],
            item: "",
        };
    },
    created() {
        this.list = this.value || [];
    },
    computed: {
        itemAlreadyExists() {
            return this.list.includes(this.item);
        },
    },
    watch: {
        value() {
            this.list = this.value || [];
        },
        list() {
            this.$emit("input", this.list);
        },
    },
    methods: {
        pushItem() {
            if (this.item && !this.list.includes(this.item) && this.item.trim()) {
                //TODO: any other validation?
                this.list.push(this.item);
                this.item = null;
            }
        },

        removeItem(t) {
            const i = this.list.indexOf(t);
            this.list.splice(i, 1);
        },
    },
};
</script>

<style scoped>
.custom-input {
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>
